import { restClient } from '../../client';
import { FormElement, FormGroup, FormSubmissionResponse } from '@uplift/types';


type FormSubmissionResultsInput = {
  submission_id: string;
};

type FormSubmissionResultsOutput = {
  title: string;
  groups: FormGroup[];
  elements: FormElement[];
  responses: {
    responses: FormSubmissionResponse[];
    updated_at: string;
    complete: boolean;
  };
};

export const formSubmissionResults = (params: FormSubmissionResultsInput) => restClient.request<FormSubmissionResultsOutput>('/api/v1/form/submission-results', {
  method: 'GET',
  params: params,
});
